var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.screenType == "0"
    ? _c("div", { staticClass: "inner-content" }, [
        _c("div", { staticClass: "title" }, [_vm._v(_vm._s(_vm.data.title))]),
        _c("div", { staticClass: "page-content" }, [
          _c("div", { staticClass: "page-leftcontent" }, [
            _c("div", { staticClass: "swiper-containerFocus" }, [
              _c(
                "div",
                { staticClass: "swiper-wrapper" },
                _vm._l(_vm.data.picture, function (item, innerIndex) {
                  return _c(
                    "div",
                    { key: innerIndex, staticClass: "swiper-slide" },
                    [
                      _c("img", {
                        staticClass: "swiper-img",
                        attrs: { src: "/dsf5" + item.path },
                      }),
                    ]
                  )
                }),
                0
              ),
              _c("div", { staticClass: "swiper-pagination" }),
            ]),
          ]),
          _c("div", {
            staticClass: "page-rightcontent",
            domProps: { innerHTML: _vm._s(_vm.data.content) },
          }),
        ]),
      ])
    : _c("div", { staticClass: "verticalGraphic" }, [
        _c("div", { staticClass: "swiper-containerFocus" }, [
          _c(
            "div",
            { staticClass: "swiper-wrapper" },
            _vm._l(_vm.data.picture, function (item, index) {
              return _c("div", { key: index, staticClass: "swiper-slide" }, [
                _c("img", {
                  staticClass: "swiper-img",
                  attrs: { src: "/dsf5" + item.path },
                }),
              ])
            }),
            0
          ),
          _c("div", { staticClass: "swiper-pagination" }),
        ]),
        _c("div", {
          staticClass: "vertical-detail",
          domProps: { innerHTML: _vm._s(_vm.data.content) },
        }),
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }